import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Button, Divider, Grid } from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddCircleOutline'
import useStyles from './PageDivider.styled'

const PageDivider = props => {
	const { className, children, disabled, onClick } = props
	const classes = useStyles(props)

	return (
		<Grid className={className} container alignItems="center">
			<Divider className={classes.divider} />
			<Grid className={classes.content} item>
				<Button
					className={classes.button}
					disabled={disabled}
					onClick={!disabled ? onClick : undefined}
					variant="text"
					color="default"
				>
					{children && <span className={classes.label}>{children}</span>}
					<AddIcon className={classes.icon} />
				</Button>
			</Grid>
			<Divider className={classes.divider} />
		</Grid>
	)
}

PageDivider.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
}

export default memo(PageDivider)
